<template>
  <div class="fileGenericBasicForm">
    <p class="fileGenericBasicForm__hint">上传资源文件后，扩展字段由后端处理写入。</p>
  </div>
</template>

<script>
import basicFormMixin from './basicFormMixin'

export default {
  name: 'FileGenericBasicForm',
  mixins: [basicFormMixin],
}
</script>

<style scoped>
.fileGenericBasicForm__hint {
  margin: 8px 0 0;
  font-size: var(--link-text-sm);
  color: var(--link-text-muted, #6b6560);
}
</style>
